import { Stack, Typography } from "@mui/material";
import SubjectAvatar from "./subject.avatar";

export default function SubjectName(props) {
	let { subject } = props;
	if (!subject?.name) {
		return;
	}

	const size = props?.size;
	const variant = props?.variant || 'subtitle1';
	const sx = { ...props.sx };

	return (
		<Stack alignItems="center" sx={sx}>
			<SubjectAvatar subject={subject} size={size} />
			<Typography variant={variant}>{subject.name}</Typography>
		</Stack>
	)
}